<template>
  <span
    class="tw-border tw-border-gp-midnight-2 tw-bg-gp-midnight-2 tw-p-px tw-italic tw-text-gp-rhino"
    ><slot
  /></span>
</template>
